import { createContext, useContext } from "react";
import PropTypes from "prop-types";

const LocaleProviderContext = createContext([]);
LocaleProviderContext.displayName = "localProvider";

export const useLocaleProvider = () => useContext(LocaleProviderContext);

export const useTranslate =
  ({ languageStrings }) =>
  (string) =>
    languageStrings[string];

export const LocaleProvider = ({
  children,
  languageStrings,
  localisedLinks,
}) => {
  return (
    <LocaleProviderContext.Provider value={{ languageStrings, localisedLinks }}>
      {children}
    </LocaleProviderContext.Provider>
  );
};

LocaleProvider.propTypes = {
  children: PropTypes.array.isRequired,
  languageStrings: PropTypes.object.isRequired,
  localisedLinks: PropTypes.object.isRequired,
};
